import { createIcon } from '@jbhi-fi/lanyard-ui/components/Icon';
import React from 'react';

export const ZipPayIcon = createIcon({
  path: (
    <>
      <path
        d="M0.978925 17.8273L1.35841 20.9189H14.644L14.2092 17.3783H8.0143L7.96017 16.9389L13.6656 12.9521L13.285 9.85372H0L0.434191 13.3949H6.63936L6.69407 13.8371L0.978925 17.8273Z"
        fill="black"
      />
      <path d="M14.8286 9.85372L16.187 20.9189H29.4828L28.1238 9.85372H14.8286Z" fill="#AA8FFF" />
      <path
        d="M43.426 13.8377C43.1194 11.3503 41.1656 9.84295 38.5103 9.85378H29.6669L31.0247 20.9189H35.0031L34.7308 18.7061H38.941C42.2556 18.7061 43.7718 16.6409 43.426 13.8377ZM38.512 15.6043L34.3524 15.6089L34.0265 12.9533L38.2094 12.9567C39.1935 12.9681 39.6966 13.522 39.7775 14.2805C39.8277 14.7678 39.6066 15.6037 38.512 15.6037V15.6043Z"
        fill="black"
      />
      <path
        d="M18.6705 8.2284C19.3702 7.47719 19.2482 6.22616 18.3981 5.43413C17.548 4.64211 16.2916 4.60902 15.5919 5.36023C14.8922 6.11144 15.0141 7.36248 15.8643 8.1545C16.7144 8.94652 17.9708 8.97961 18.6705 8.2284Z"
        fill="black"
      />
    </>
  ),
  viewBox: '0 0 44 25',
  defaultProps: {
    height: 25,
    width: 'auto',
  },
});
